import { isEmpty } from "lodash";

const constructBoxData = (data) => {
  if (isEmpty(data)) return [];

  return {
    boxName: data?.box.name || data?.box.code,
    boxNo: "1",
    location: data?.sortingHubName,
    numOfParcels: data?.noOfParcels,
    status: data?.status,
    noOfExpectedParcels : data.noOfExpectedParcels ,
    isScanned: data.scanned || false
  };
};

const response = (data) => {
  if (isEmpty(data?.slots)) return data;

  const result = {
    ...data,
    slots: data.slots.map((s, i) => ({
      ...s,
      columnNo: s.name || (i + 1).toString(),
      boxInfo: constructBoxData(s.boxData),
    })),
  };

  return result;
};

export default response;
